import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { vehicleSchema } from '../schemas/vehicle.schema';

/**
 * Requests the Vehicles associated with a specific Vehicle Group
 * @param vehicleGroupId The ID of the Vehicle Group whose Vehicles are being requested
 * @returns The Vehicles
 */
export function getVehicleGroupsIdVehicles(
  this: unknown,
  vehicleGroupId: number
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsIdVehiclesUrl(vehicleGroupId),
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(vehicleSchema),
      })
    )
  );
}
